import {
  getQueryObj
} from '../utility/functions';

export default function setNewsFillter() {

  /* Element */
  const wrapElm = document.querySelectorAll('.p-news');
  const fillter = document.querySelectorAll('.js-newsFillter');
  const label = document.querySelectorAll('.js-newsLabel');
  const year = document.getElementById('js-year');
  const category = document.getElementById('js-category');

  /* location */
  const url = location.protocol + '//' + location.host + '/news/';
  const hashObj = getQueryObj();
  let href, type, val;
  Array.from(fillter).forEach((elm) => {
    elm.addEventListener('click', (e) => {
      type = e.target.getAttribute('data-type');
      val = e.target.getAttribute('data-metavalue');
      if (type == 'year') {
        href = url + '?y=' + val
      } else {
        href = url + '?category=' + val
      }
      location.href = href;
      wrapElm[0].style.display = 'none';
    })
  });

  /* パラメータが付与されている時にlabelのカレントを合わせる */
  if (hashObj['y']) {
    label[0].innerHTML = hashObj['y'].toUpperCase();
    year.classList.add('is-sort');
    category.classList.remove('is-sort');
  }
  if (hashObj['category']) {
    label[1].innerHTML = hashObj['category'].toUpperCase();
    category.classList.add('is-sort');
    year.classList.remove('is-sort');
  }

}